export enum NachrichtenFilter {
  ALL = 'ALL',
  JC = 'JC',
  AA = 'AA',
}
